module.exports = __webpack_public_path__ + "static/media/dry-van-with-arrow-right.4b376a33.svg";